// Stand-in cards the Home landing shows when a section cannot be loaded, so the page still reads as a
// workbench. They are marked "Sample" and cannot be opened. No countries, no dates.

export interface LandingSample {
  id: string;
  name: string;
}

export const LANDING_SAMPLES: readonly LandingSample[] = [
  { id: "sample-city-centre", name: "Sample · City centre" },
  { id: "sample-harbour", name: "Sample · Harbour" },
  { id: "sample-ring-road", name: "Sample · Ring road" },
];
